import React from "react"
import ReactDOM from "react-dom/client"
import { App } from "./App"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import { FlagsmithProvider } from "flagsmith/react"
import flagsmith from "flagsmith"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <FlagsmithProvider
      options={{
        environmentID:
          process.env.REACT_APP_FLAGSMITH_ENV_ID || "MvRmaoTPPJemHwPyRbzxu6",
      }}
      flagsmith={flagsmith}
    >
      <App />
    </FlagsmithProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
